// extracted by mini-css-extract-plugin
module.exports = {"tdStyle":"O7Y6A"};